import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentGrievanceComponent } from 'src/app/view/ugc-compliance/student-grievance/student-grievance.component';
import { InternalComplaintComponent } from 'src/app/view/ugc-compliance/internal-complaint/internal-complaint.component';
import { StrategicPlanComponent } from 'src/app/view/ugc-compliance/strategic-plan/strategic-plan.component';
import { UgcFeeRefundComponent } from 'src/app/view/ugc-compliance/ugc-fee-refund/ugc-fee-refund.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedModule } from '../shared/shared.module';

import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        StudentGrievanceComponent,
        InternalComplaintComponent,
        StrategicPlanComponent,
        UgcFeeRefundComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([
            { path: 'student-grievance', component: StudentGrievanceComponent },
            { path: 'internal-complaint', component: InternalComplaintComponent },
            { path: 'strategic-plan', component: StrategicPlanComponent },
            { path: 'fee-refund-policy', component: UgcFeeRefundComponent }
        ]),
        PdfViewerModule,
        SharedModule
    ]
})
export class UgcComplianceModule { }
